import { useImpersonationStore } from '@/stores/impersonationStore'
import { api } from '@/lib/api'

export function ImpersonationBanner() {
  const { isImpersonating, targetUserName, targetUserEmail, sessionId, expiresAt, exitImpersonation } =
    useImpersonationStore()

  if (!isImpersonating) return null

  const minutesLeft = expiresAt
    ? Math.max(0, Math.floor((new Date(expiresAt).getTime() - Date.now()) / 60_000))
    : 0

  async function handleExit() {
    // Best-effort server-side revocation using the admin's real token (api.admin)
    if (sessionId) {
      try {
        await api.admin.delete(`/api/v1/admin/impersonations/${sessionId}`)
      } catch { /* ignore — KV TTL handles cleanup */ }
    }
    exitImpersonation()
    // Full page reload to reset all React state cleanly
    window.location.replace('/admin/users')
  }

  return (
    <div
      className="fixed inset-x-0 top-0 z-[9999] flex h-10 items-center justify-between
                 bg-amber-500 px-4 text-sm font-medium text-black shadow"
    >
      <span>
        Impersonating{' '}
        <strong>{targetUserName ?? targetUserEmail ?? 'unknown'}</strong>
        {minutesLeft > 0 && (
          <span className="ml-2 opacity-70">— expires in {minutesLeft}m</span>
        )}
      </span>
      <button
        onClick={() => void handleExit()}
        className="rounded bg-black/20 px-3 py-1 text-xs font-semibold hover:bg-black/30 transition-colors"
      >
        Exit impersonation
      </button>
    </div>
  )
}
